module.exports = __webpack_public_path__ + "static/armor_of_resistance-27248404dedc4c8b33b737c6b105c906.jpeg";